import * as React from 'react'
import useAccount from '../useAccount'
import * as api from '../useAccount/cart/api'
import * as t from '../types'

export default function usePromotionCodes() {
  const account = useAccount()
  const [items, setItems] = React.useState<t.PromotionItem[]>([])
  const [adding, setAdding] = React.useState(false)
  const [systemError, setSystemError] = React.useState(false)
  const [notFoundError, setNotFoundError] = React.useState(false)
  const [added, setAdded] = React.useState(false)

  React.useEffect(() => {
    setItems(account.cart.data.promotionItems)
  }, [account.cart.data.promotionItems])

  return {
    items: items,
    adding: adding,
    status: account.cart.data.promotionStatus,
    systemError,
    added,
    notFoundError,
    // removeCode: async () => {
    //   if(!item) return false
    //   const prev = item
    //   setItem(null)
    //   const result = await api.removeItem(item.cartItemId)

    //   if(result.status === 200) {
    //     account._.sendEvent({type: 'PROMOTION_CODE_REMOVE', cart: result.payload})
    //     return true
    //   }

    //   setItem(prev)
    //   return false
    // },
    addCode: async (code: string) => {
      if (systemError) setSystemError(false)
      if (notFoundError) setNotFoundError(false)
      if (added) setAdded(false)
      setAdding(true)
      const result = await api.addPromotion(code)

      if (result.status === 200) {
        account._.sendEvent({
          type: 'PROMOTION_CODE_ADD',
          code: code,
          cart: result.payload
        })
        setItems(result.payload.promotionItems)
        setAdding(false)
        setAdded(true)
        return true
      }

      if (result.status === 400) {
        setNotFoundError(true)
        setAdding(false)
        return false
      }

      setSystemError(true)
      setAdding(false)
      return false
    }
  }
}
